// Réinitialisation du mot de passe, directement auprès de Supabase Auth.
// La clé ci-dessous est la clé *publique* (publishable) du projet : elle est
// faite pour être embarquée dans une application. Ne jamais mettre ici la clé secrète.
export const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://wtlstbgmjjkcklrrsydp.supabase.co';
export const SUPABASE_PUBLISHABLE_KEY = process.env.REACT_APP_SUPABASE_KEY || 'sb_publishable_6z7a7C2E0cNIWikX-Cw4WA_5IS13FpF';
const APP_URL = 'https://app.nowatt.app';

export const MIN_PASSWORD_LENGTH = 8;

const headers = (token) => ({
  'Content-Type': 'application/json',
  apikey: SUPABASE_PUBLISHABLE_KEY,
  Authorization: `Bearer ${token || SUPABASE_PUBLISHABLE_KEY}`,
});

// Envoie l'email contenant le lien de réinitialisation.
export async function requestPasswordReset(email) {
  const res = await fetch(`${SUPABASE_URL}/auth/v1/recover?redirect_to=${encodeURIComponent(APP_URL)}`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ email }),
  });
  if (res.status === 429) throw new Error('RATE_LIMIT');
  if (!res.ok) throw new Error('REQUEST_FAILED');
}

// Enregistre le nouveau mot de passe avec le jeton reçu via le lien de l'email.
export async function updatePassword(accessToken, password) {
  const res = await fetch(`${SUPABASE_URL}/auth/v1/user`, {
    method: 'PUT',
    headers: headers(accessToken),
    body: JSON.stringify({ password }),
  });
  if (res.ok) return;
  let code = '';
  try { const d = await res.json(); code = d.error_code || d.code || ''; } catch (e) { /* réponse non JSON */ }
  if (code === 'same_password') throw new Error('SAME_PASSWORD');
  if (code === 'weak_password') throw new Error('WEAK_PASSWORD');
  if (res.status === 401 || res.status === 403) throw new Error('LINK_EXPIRED');
  throw new Error('REQUEST_FAILED');
}

// Lit le fragment d'URL posé par Supabase après un clic sur le lien de l'email.
// Retourne { accessToken } pour un lien valide, { error: true } pour un lien
// expiré ou déjà utilisé, ou null si l'URL ne concerne pas une réinitialisation.
export function readRecoveryFromUrl() {
  const hash = window.location.hash.replace(/^#/, '');
  if (!hash) return null;
  const p = new URLSearchParams(hash);
  if (p.get('type') === 'recovery' && p.get('access_token')) return { accessToken: p.get('access_token') };
  if (p.get('error') && /otp|expired|invalid|access_denied/i.test(`${p.get('error_code')} ${p.get('error')}`)) return { error: true };
  return null;
}

// Retire le jeton de la barre d'adresse et de l'historique du navigateur.
export function clearRecoveryFromUrl() {
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
}
